import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { getImageUrl } from "src/Common/common";

const AssignedOptions = ({ onEdit, onDuplicate, onUnassign, onClose }) => {
  return (
    <OutsideClickHandler onOutsideClick={onClose}>
      <div className="flex flex-col items-center py-1 gap-2 absolute top-[24px] right-0 w-[30px] border-[1px] rounded-[6px] border-borderColor bg-white z-20 shadow-md">
        <img
          onClick={onEdit}
          className="w-[14px] h-[14px] object-contain cursor-pointer"
          src={getImageUrl("/images/common/edit.png")}
          alt="Edit"
          title="Edit"
        />
        <img
          onClick={onDuplicate}
          className="w-[15px] h-[15px] object-contain cursor-pointer"
          src={getImageUrl("/images/common/white_duplicate.png")}
          alt="Duplicate"
          title="Duplicate"
        />
        <img
          onClick={onUnassign}
          className="w-[14px] h-[14px] object-contain cursor-pointer"
          src={getImageUrl("/images/common/white_repeat.png")}
          alt="Unassign"
          title="Unassign"
        />
      </div>
    </OutsideClickHandler>
  );
};

export default AssignedOptions;
